module.exports = __webpack_public_path__ + "static/img/cs1.d090876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/cs1.png
// module id = 302
// module chunks = 34